/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glacial acetic acid (density 1.05, assay 99.7%, EW 60.05): N ≈ 17.4 N.`)
};

const es_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ácido acético glacial (densidad 1.05, ensayo 99.7%, PE 60.05): N ≈ 17.4 N.`)
};

const de_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eisessig (Dichte 1,05, Gehalt 99,7%, EW 60,05): N ≈ 17,4 N.`)
};

const nl_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IJsazijn (dichtheid 1,05, gehalte 99,7%, EW 60,05): N ≈ 17,4 N.`)
};

const fr_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acide acétique glacial (densité 1,05, titre 99,7 %, EG 60,05) : N ≈ 17,4 N.`)
};

const it_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acido acetico glaciale (densità 1,05, titolo 99,7%, PE 60,05): N ≈ 17,4 N.`)
};

const pt_br2_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ácido acético glacial (densidade 1,05, teor 99,7%, PE 60,05): N ≈ 17,4 N.`)
};

const pt_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ácido acético glacial (densidade 1,05, título 99,7%, EG 60,05): N ≈ 17,4 N.`)
};

const ja_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氷酢酸 (密度1.05、アッセイ99.7%、当量60.05): N ≈ 17.4 N。`)
};

const zh_norm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冰醋酸（密度 1.05，含量 99.7%，当量重量 60.05）：N ≈ 17.4 N。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_ex3", locale)
	if (locale === "en") return en_norm_ex3(inputs)
	if (locale === "es") return es_norm_ex3(inputs)
	if (locale === "de") return de_norm_ex3(inputs)
	if (locale === "nl") return nl_norm_ex3(inputs)
	if (locale === "fr") return fr_norm_ex3(inputs)
	if (locale === "it") return it_norm_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_norm_ex3(inputs)
	if (locale === "pt") return pt_norm_ex3(inputs)
	if (locale === "ja") return ja_norm_ex3(inputs)
	return zh_norm_ex3(inputs)
};